import { ComponentProps } from "react";

export function NearbyStory(props: ComponentProps<"svg">) {
    return (
        <svg {...props} width="40" height="40" viewBox="0 0 40 40">
            <path d="M23.4983 32.7262C23.1089 33.6348 22.1355 34.154 21.162 33.9593C20.1885 33.7646 19.4746 32.9209 19.4746 31.8826V20.4605H8.05253C7.07906 20.4605 6.23538 19.8115 6.04069 18.838C5.84599 17.8645 6.36518 16.8911 7.27376 16.5017L30.118 7.15632C30.8967 6.83183 31.8053 7.02652 32.3894 7.61061C32.9735 8.19469 33.1682 9.10327 32.8437 9.88205L23.4983 32.7262Z" />
        </svg>
    );
}
